module.exports = "/static/assets/559ff3f97ba4e20648b7846943d9fe33.png";